import {
  Checkbox,
  Form,
  FormInstance,
  Input,
  notification,
  Spin,
  Tooltip,
  Upload,
} from "antd";
import { AppPartType } from "../../AppForm/types";
import { get, isNil, uniqueId } from "lodash";
import { useSelector } from "react-redux";
import { user } from "@lhd/features/users/selector";
import axios from "@lhd/libs/axios";
import { LIMIT_UPLOAD_ATTACHMENT, ONE_MB, SERVICES } from "@lhd/constants";
import {
  DeleteOutlined,
  LoadingOutlined,
  PaperClipOutlined,
} from "@ant-design/icons";
import CustomImage from "@lhd/components/CustomImage";
import { Suspense, useEffect, useRef, useState } from "react";
import { RcFile, UploadFile } from "antd/lib/upload";
import ModalVideo from "../ModalVideo";
import { fileCanPreview, getIdFromUrlAttactment } from "../../utils";
import IconDownload from "../IconDownload";
import { StyleLabelRequired, Styles } from "./style";
import React from "react";
const ModalPreviewOffice = React.lazy(
  () => import("@lhd/components/Modal/ModalPreviewOffice"),
);

const HEIGHT_MEDIA = 150;
const WIDTH_MEDIA = "100%";

interface IProps {
  labelText?: string;
  form: FormInstance<any>;
  item: AppPartType;
  isDisable: boolean;
  isHiddleLabel?: boolean;
  isAllowEditColumn?: boolean;
  listFileUploaded: any;
  setListFileUploaded: React.Dispatch<any>;
  listUpdateAllowDownload?: any;
  setListUpdateAllowDownload?: React.Dispatch<any>;
  setListFileRemove?: React.Dispatch<any>;
  listFileRemove?: any;
  nameField?: string;
  selector?: string;
  multiple?: boolean;
  isTable?: boolean;
  setAllowDownLoad: React.Dispatch<any>;
  allowDownLoad: any;
  onUploadStatusChange?: (isUploading: boolean) => void;
  styleColor?: any;
  className?: string;
}

const Attachment = (props: IProps) => {
  const {
    labelText,
    form,
    item,
    isDisable,
    isHiddleLabel,
    listFileUploaded,
    setListFileUploaded,
    listUpdateAllowDownload,
    setListUpdateAllowDownload,
    isAllowEditColumn,
    listFileRemove,
    setListFileRemove,
    nameField,
    isTable,
    multiple = true,
    setAllowDownLoad,
    allowDownLoad,
    onUploadStatusChange,
    styleColor,
    className,
  } = props;
  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const name = nameField || item.id?.toString() || "";
  const auth = useSelector(user);
  const fileTtmUploadeds = useRef<{ [key: string]: string }>({});
  const [openModal, setOpenModal] = useState(false);
  const [urlPreviewOffice, setUrlPreviewOffice] = useState<string>();

  const handleUpdateListDownload = async (
    fileOld: any,
    checked: boolean,
    id?: string,
  ) => {
    if (!setListUpdateAllowDownload) return;
    const idURL = getIdFromUrlAttactment(fileOld.urlToGet);
    if (id && idURL) {
      const cloneListUpdateAllowDownload = { ...listUpdateAllowDownload };
      cloneListUpdateAllowDownload[idURL] = {
        value: fileOld.urlToGet,
        is_allow_download_attachment: checked,
        app_part_id: id,
        id: fileOld.id,
        sort_index: 0,
      };
      setListUpdateAllowDownload(cloneListUpdateAllowDownload);
    }
  };
  useEffect(() => {
    return () => {
      Object.values(fileTtmUploadeds.current).forEach((blobUrl) =>
        URL.revokeObjectURL(blobUrl),
      );
    };
  }, []);

  const handleUploadFile = async (options: any, id?: string) => {
    if (options?.file) {
      onUploadStatusChange?.(true);
      const blobUrl = URL.createObjectURL(options.file);
      const key = options.file.uid;
      fileTtmUploadeds.current = {
        ...fileTtmUploadeds.current,
        [key]: blobUrl,
      };
    }
    if (!id) {
      onUploadStatusChange?.(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", options.file);

    if (multiple) {
      const oldList =
        form?.getFieldValue(id)?.filter((file: any) => !file.status) || [];
      form.setFieldValue(id, [...oldList, options.file]);
    } else {
      form.setFieldValue(id, [options.file]);
    }

    try {
      const response = await axios.post(SERVICES.UPLOAD_ATTACHMENT, formData);
      if (id) {
        if (isTable) {
          setListFileRemove &&
            setListFileRemove({
              ...listFileRemove,
              [String(item.id)]:
                listFileRemove[String(item.id)]?.filter(
                  (file: any) => file.name !== id,
                ) || [],
            });
        }
        setListFileUploaded((listFileOld: any) => {
          if (!multiple) {
            return {
              ...listFileOld,
              [id]: [
                {
                  url: response.data.url,
                  uid: (options.file as any).uid,
                },
              ],
            };
          }

          return {
            ...listFileOld,
            [id]: listFileOld[id]
              ? [
                  ...listFileOld[id],
                  {
                    url: response.data.url,
                    uid: (options.file as any).uid,
                  },
                ]
              : [
                  {
                    url: response.data.url,
                    uid: (options.file as any).uid,
                  },
                ],
          };
        });
      }
    } finally {
      onUploadStatusChange?.(false);
    }
  };

  const handlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    item: AppPartType,
  ) => {
    if (isDisable) return;
    const clipboardData = e.clipboardData;
    const nameItem = item.id?.toString();
    if (!clipboardData || !nameItem) return;
    const items = clipboardData.items;

    for (let i = 0; i < items.length; i++) {
      const itemCopy = items[i];

      if (itemCopy.kind === "file") {
        const file = itemCopy.getAsFile() as RcFile;
        if (file) {
          const validateResult = handleValidateFile(file);
          if (validateResult !== Upload.LIST_IGNORE) {
            const fileAs = file as any;
            fileAs.uid = uniqueId("uid");
            handleUploadFile({ file: fileAs }, name);
          }
        }
      }
    }
  };

  const handleValidateFile = (file: RcFile) => {
    if (file.size > LIMIT_UPLOAD_ATTACHMENT * ONE_MB * 10) {
      notification.error({
        message: `ファイルは${LIMIT_UPLOAD_ATTACHMENT}MB以下である必要があります。!`,
      });
      return Upload.LIST_IGNORE;
    }
  };

  const renderContent = (
    file: UploadFile<any>,
    url: any,
    isUploading: boolean,
  ) => {
    const extension = fileCanPreview(url);
    return file.type?.includes("image") || file.type?.includes("video") ? (
      <div
        style={{
          display: "inline-block",
          width: WIDTH_MEDIA,
        }}
      >
        {file.type?.includes("image") ? (
          <CustomImage
            width={"100%"}
            height={"100%"}
            style={{
              maxHeight: HEIGHT_MEDIA,
            }}
            src={
              fileTtmUploadeds.current[file.uid as any]
                ? fileTtmUploadeds.current[file.uid as any]
                : url
            }
          />
        ) : (
          <ModalVideo
            src={
              fileTtmUploadeds.current[file.uid as any]
                ? fileTtmUploadeds.current[file.uid as any]
                : url
            }
          />
        )}
      </div>
    ) : (
      <p
        onClick={() => {
          if (!extension) return;
          extension && setOpenModal(true);
          setUrlPreviewOffice(url);
        }}
        style={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          width: "100%",
          color: styleColor?.color || (extension ? "#1890ff" : "black"),
          cursor: extension ? "pointer " : "auto",
        }}
      >
        {file.name}
      </p>
    );
  };

  const formItemContent = (
    <Styles
      className={`${isTable ? "attachment-table" : "attachment"} ${
        isDisable ? "disabled" : ""
      } `}
    >
      <Form.Item
        name={name}
        valuePropName="fileList"
        getValueFromEvent={normFile}
        noStyle
        rules={[
          {
            required: item?.is_required_field,
            message: "ファイルを選択してください",
          },
        ]}
      >
        <Upload.Dragger
          name="files"
          multiple={multiple}
          itemRender={(_, file, files, action) => {
            const filesHaveUploaded = listFileUploaded[name as string] || [];
            const fileAs = file as any;
            let url = fileAs.urlToGet || fileAs.url;
            if (!url) {
              const filesHaveUploaded = listFileUploaded[name as any];
              url = filesHaveUploaded?.find(
                (x: any) => x.uid === file.uid,
              )?.url;
              fileAs.urlToGet = url;
            }
            const isUploading = !url;

            const id = getIdFromUrlAttactment(url || "");
            const isAllowDownload = get(
              allowDownLoad,
              `[${id}]`,
              !!fileAs.is_allow_download_attachment,
            );

            return (
              <div
                className="item-list-file"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "3px 2px",
                  background: styleColor?.background || "#fff",
                  ...styleColor,
                }}
              >
                <div className="item-list-file-content">
                  {isUploading && (
                    <div
                      style={{
                        background: "rgb(0, 0, 0, 0.5)",
                        position: "absolute",
                        top: 0,
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 10,
                      }}
                    >
                      <Spin
                        style={{
                          color: "#fff",
                        }}
                        indicator={<LoadingOutlined spin />}
                        size="small"
                      />
                    </div>
                  )}
                  {renderContent(file, url, isUploading)}
                </div>
                <div
                  className="actions_file"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "4px",
                  }}
                >
                  <Tooltip title="ダウンロード可能を選択">
                    <Checkbox
                      disabled={
                        (!isNil(fileAs.id)
                          ? auth?.id != fileAs.user_id
                          : false) || isDisable
                      }
                      defaultChecked={!!fileAs.is_allow_download_attachment}
                      onChange={(e) => {
                        const id = getIdFromUrlAttactment(url || "");
                        if (fileAs.id) {
                          handleUpdateListDownload(
                            fileAs,
                            e.target.checked,
                            name,
                          );
                        }
                        setAllowDownLoad((preState: any) => {
                          return { ...preState, [id]: e.target.checked };
                        });
                      }}
                    />
                  </Tooltip>
                  <IconDownload
                    url={url}
                    isUploading={isUploading}
                    isDisabled={!isAllowDownload}
                  />
                  <DeleteOutlined
                    style={{
                      opacity: isDisable ? 0.5 : 1,
                      cursor: isDisable ? "not-allowed" : "pointer",
                    }}
                    onClick={() => {
                      if (isDisable) return;
                      const newFilesHaveUploaded = filesHaveUploaded.filter(
                        (fileUploaded: any) =>
                          fileUploaded.url !== (file as any).urlToGet,
                      );
                      action.remove();
                      const listFileUploadedClone = {
                        ...listFileUploaded,
                      };
                      listFileUploadedClone[name as string] =
                        newFilesHaveUploaded;

                      setListFileUploaded(listFileUploadedClone);
                    }}
                  />
                </div>
              </div>
            );
          }}
          customRequest={(options) => handleUploadFile(options, name)}
          beforeUpload={handleValidateFile}
          progress={{
            strokeWidth: 5,
            showInfo: true,
          }}
          disabled={!isAllowEditColumn || isDisable}
          onRemove={(fileOp: any) => {
            if (!setListFileRemove) return;
            const newListFileUploaded = listFileUploaded[name].filter(
              (x: any) => x.uid !== fileOp.uid,
            );
            setListFileUploaded(newListFileUploaded);
            const dataRecordValueRemove = {
              id: fileOp?.id,
              app_part_id: item?.id,
              value: "",
              sort_index: 0,
              is_delete: true,
              name: name,
            };
            const newListFileRemove = { ...listFileRemove };
            if (dataRecordValueRemove.app_part_id) {
              if (!newListFileRemove[dataRecordValueRemove.app_part_id]) {
                newListFileRemove[dataRecordValueRemove.app_part_id] = [];
              }
              newListFileRemove[dataRecordValueRemove.app_part_id] = [
                ...newListFileRemove[dataRecordValueRemove.app_part_id],
                dataRecordValueRemove,
              ];
            }
            setListFileRemove(newListFileRemove);
          }}
        >
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Input
              onClick={(e) => e.stopPropagation()}
              value={""}
              onPaste={(e) => handlePaste(e, item)}
            />
            <div
              className="icon_attachment"
              style={{
                width: 40,
                height: 40,
                fontSize: 30,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderLeft: "1px dashed #d9d9d9",
              }}
            >
              <PaperClipOutlined />
            </div>
          </div>
        </Upload.Dragger>
      </Form.Item>
      {openModal && (
        <Suspense fallback={<Spin />}>
          <ModalPreviewOffice
            modalProps={{
              destroyOnClose: true,
              open: openModal,
              onCancel: () => {
                setOpenModal(false);
              },
            }}
            uri={urlPreviewOffice}
          />
        </Suspense>
      )}
    </Styles>
  );

  return isHiddleLabel ? (
    formItemContent
  ) : (
    <Form.Item
      label={
        isHiddleLabel ? (
          <div></div>
        ) : (
          <div>
            {item?.is_required_field && (
              <StyleLabelRequired>*</StyleLabelRequired>
            )}
            {item.label_text || labelText}
          </div>
        )
      }
      className={className}
      validateTrigger="onBlur"
    >
      {formItemContent}
    </Form.Item>
  );
};

export default Attachment;
